/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../api/types.generated";
export type GetRegistrationBadgeProfileQueryVariables = Types.Exact<{
  userId: Types.Scalars["Int"];
  extendedProfileUserId: Types.Scalars["Float"];
}>;

export type GetRegistrationBadgeProfileQuery = {
  users: Array<Pick<Types.User, "email">>;
  getExtendedProfile?: Types.Maybe<{
    scannee?: Types.Maybe<{
      fields_HACKTHENORTH2026_EXTENDED_PROFILES: {
        answers: {
          badge_display_name: Pick<Types.StringFieldAnswerTypeWrapper, "value">;
          interests: Pick<Types.StringFieldAnswerTypeWrapper, "value">;
        };
      };
    }>;
  }>;
  claims: Array<
    Pick<Types.Claim, "id"> & {
      stage: Pick<Types.Stage, "slug">;
      fields_HACKTHENORTH2026_APPLICATIONS: {
        answers: {
          networking_phone_number: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          networking_email: Pick<Types.StringFieldAnswerTypeWrapper, "value">;
          networking_linkedin_link: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          networking_instagram_link: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          networking_twitter_link: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          networking_discord_tag: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          rsvp_legal_name: Pick<Types.StringFieldAnswerTypeWrapper, "value">;
          rsvp_consent_waiver_signature: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          rsvp_consent_waiver: {
            value?: Types.Maybe<Array<Pick<Types.FileFieldAnswerType, "id">>>;
          };
        };
      };
    }
  >;
};

export const GetRegistrationBadgeProfileDocument = gql`
  query GetRegistrationBadgeProfile(
    $userId: Int!
    $extendedProfileUserId: Float!
  ) {
    users(take: 1, where: { id: { equals: $userId } }) {
      email
    }
    getExtendedProfile(user_id: $extendedProfileUserId) {
      scannee {
        fields_HACKTHENORTH2026_EXTENDED_PROFILES {
          answers {
            badge_display_name {
              value
            }
            interests {
              value
            }
          }
        }
      }
    }
    claims(
      take: 1
      where: {
        pipeline: { is: { slug: { equals: "hackthenorth2026-applications" } } }
        user_id: { equals: $userId }
      }
    ) {
      id
      stage {
        slug
      }
      fields_HACKTHENORTH2026_APPLICATIONS {
        answers {
          networking_phone_number {
            value
          }
          networking_email {
            value
          }
          networking_linkedin_link {
            value
          }
          networking_instagram_link {
            value
          }
          networking_twitter_link {
            value
          }
          networking_discord_tag {
            value
          }
          rsvp_legal_name {
            value
          }
          rsvp_consent_waiver_signature {
            value
          }
          rsvp_consent_waiver {
            value {
              id
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetRegistrationBadgeProfileQuery__
 *
 * To run a query within a React component, call `useGetRegistrationBadgeProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrationBadgeProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrationBadgeProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      extendedProfileUserId: // value for 'extendedProfileUserId'
 *   },
 * });
 */
export function useGetRegistrationBadgeProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetRegistrationBadgeProfileQuery,
    GetRegistrationBadgeProfileQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetRegistrationBadgeProfileQuery,
    GetRegistrationBadgeProfileQueryVariables
  >(GetRegistrationBadgeProfileDocument, baseOptions);
}
export function useGetRegistrationBadgeProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetRegistrationBadgeProfileQuery,
    GetRegistrationBadgeProfileQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetRegistrationBadgeProfileQuery,
    GetRegistrationBadgeProfileQueryVariables
  >(GetRegistrationBadgeProfileDocument, baseOptions);
}
export type GetRegistrationBadgeProfileQueryHookResult = ReturnType<
  typeof useGetRegistrationBadgeProfileQuery
>;
export type GetRegistrationBadgeProfileLazyQueryHookResult = ReturnType<
  typeof useGetRegistrationBadgeProfileLazyQuery
>;
export type GetRegistrationBadgeProfileQueryResult =
  ApolloReactCommon.QueryResult<
    GetRegistrationBadgeProfileQuery,
    GetRegistrationBadgeProfileQueryVariables
  >;
